import { buildProductArgs } from 'Utils/graphql';
import gqlClient from 'Utils/graphql-client/graphqlClient';
import { STATE_PRODUCT_PRICE_TICKET } from 'Utils/request/requestDictionary';
import { QUERY_DEPARTURE_DATE, QUERY_DURATION, QUERY_TRANSPORT } from 'Utils/uri/constants';
import { url as urlUtils } from '@clubmed/utils';
export const getProductArgs = ({
  duration,
  location,
  productId,
  transport,
  withDate,
}: {
  duration?: number;
  location: ProductRouterLocation;
  productId: string;
  transport?: string;
  withDate?: boolean;
}) => {
  const { queryParams, urlParams } = location;
  const offerName = urlUtils.decodePath(queryParams.offer) || '';
  const tripDuration = withDate ? duration || queryParams[QUERY_DURATION] : null;
  const productArgsToBuild: Record<string, string | number> = {};
  productArgsToBuild.offerName = offerName;
  productArgsToBuild.date = withDate ? queryParams[QUERY_DEPARTURE_DATE] || '' : '';
  productArgsToBuild.departureCity = transport || queryParams[QUERY_TRANSPORT] || '';

  if (tripDuration) {
    productArgsToBuild.duration = parseInt(tripDuration, 10);
  }

  return buildProductArgs(productId, urlParams, productArgsToBuild);
};

function fetchPrice({
  appContext,
  duration,
  forceAdultPerTrip = false,
  location,
  productId,
  transport,
  withDate = true,
}: {
  appContext: AppContext;
  duration?: number;
  forceAdultPerTrip?: boolean;
  location: ProductRouterLocation;
  productId: string;
  transport?: string;
  withDate?: boolean;
}): Promise<PriceTicketRequestActionPayload> {
  const { queryParams } = location;
  const offerName = urlUtils.decodePath(queryParams.offer) || '';
  const { cmsContent = '', cmsRelease = '' } = appContext;
  const productArgs = getProductArgs({
    duration,
    location,
    productId,
    transport,
    withDate,
  });
  const cmsArgs = `content: "${cmsContent}", release: "${cmsRelease}"`;
  const query = `query {
    price(${productArgs}) {
      offerColor( offerName : "${offerName}")
      bestPrice(forceAdultPerTrip: ${String(forceAdultPerTrip)}) {
        value
        formattedValue
      }
      initialPrice(forceAdultPerTrip: ${String(forceAdultPerTrip)}) {
        value
        formattedValue
      }
      unit(${cmsArgs})
      currency
      productId
      termsAndConditions {
        departureDate
        duration
        durationFormatted(${cmsArgs})
        departureCity {
          value
          name
        }
        numberOfAdults
        accommodationComfortLabel
        accommodationId
        offerId
      }
    }
  }`;
  return gqlClient.runQuery(query, appContext, {
    requestName: STATE_PRODUCT_PRICE_TICKET,
  });
}

export { fetchPrice };
